<div
  class="page-container"
  [class.no-min-height]="disableMinHeight"
  style="overflow: {{ overflow }}"
>
  <ng-container *ngIf="!loadingFailed; else loadingFailedTemplate">
    <ng-content></ng-content>
    <div class="loading-overlay" *ngIf="loading">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </ng-container>
</div>
<ng-template #loadingFailedTemplate>
  <article class="loading-failed">
    {{ loadingFailed }}
  </article>
</ng-template>
